import React, { useCallback, useState } from "react";
import { graphql, useMutation } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WAWidgetSizeToOverviewSize } from "../../WidgetAdd/utils/WAWidgetSizeToOverviewSize";

import { overviewWidgetSizes } from "../../WidgetAdd/utils/widgetSizes/overviewWidgetSizes";
import { UserLoggedInNavigatorScreenProps } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WidgetScreen } from "../../common/WidgetScreen";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { useWidgetEmployeeLeaveSchedulePreviewQueryLoader } from "./useWidgetEmployeeLeaveSchedulePreviewQueryLoader";
import { WidgetEmployeeLeavePreview } from "./WidgetEmployeeLeavePreview";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { WAEmployeeLeaveMutation } from "./__generated__/WAEmployeeLeaveMutation.graphql";
import { WidgetEmployeeLeaveSettingsNavigator } from "./WidgetEmployeeLeaveSettingsNavigator";
import { WidgetSettingsEmployeeLeaveContextProvider } from "./WidgetEmployeeLeaveSettingsContext";

type Props = UserLoggedInNavigatorScreenProps<"WidgetAddEmployeeLeave">;

export const WAEmployeeLeave = withWebModal(WAEmployeeLeaveC, true);
function WAEmployeeLeaveC(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWAEmployeeLeave {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWAEmployeeLeave(props: Props & { fetchKey: string }) {
  const [teamIds, setTeamIds] = useState(props.route.params.defaultTeams);
  const [leaveReasonIds, setLeaveReasonIds] = useState<string[]>([]);

  const query = useWidgetEmployeeLeaveSchedulePreviewQueryLoader({
    storecastId: props.route.params.storecastId,
    teamIds,
    leaveReasonIds,
  });

  const [createWidgetEmployeeLeave, loading] =
    useMutation<WAEmployeeLeaveMutation>(graphql`
      mutation WAEmployeeLeaveMutation(
        $storecastId: ID!
        $input: CreateWidgetEmployeeLeaveInput!
      ) {
        dashboard(dashboardId: $storecastId) {
          createWidgetEmployeeLeave(widget: $input) {
            id
          }
        }
      }
    `);

  const onCreate = useCallback(
    (size: WidgetSizeT) => {
      const position = props.route.params.position;
      createWidgetEmployeeLeave({
        variables: {
          storecastId: props.route.params.storecastId,
          input: {
            positionX: position.x + position.c * 2,
            positionY: position.y,
            size: WAWidgetSizeToOverviewSize(size),
            teamIds,
            whitelistLeaveReasonIds: leaveReasonIds,
          },
        },
        onError: (e) => {
          console.log("e", e);
        },
        onCompleted: () => {
          props.navigation.pop(2);
        },
      });
    },
    [
      createWidgetEmployeeLeave,
      props.navigation,
      props.route.params.position,
      props.route.params.storecastId,
      teamIds,
      leaveReasonIds,
    ]
  );

  const renderPreview = useCallback(
    () =>
      query ? (
        <WidgetEmployeeLeavePreview
          storecastId={props.route.params.storecastId}
          query={query}
        />
      ) : null,
    [props.route.params.storecastId, query]
  );
  return (
    <WidgetScreen
      preview={
        <WASizePreview
          onCreate={onCreate}
          loading={loading}
          unitSize={props.route.params.unitSize}
          maxSize={props.route.params.maxSize}
          widgetSizes={overviewWidgetSizes}
        >
          {renderPreview}
        </WASizePreview>
      }
      settings={
        <WidgetSettingsEmployeeLeaveContextProvider
          value={{
            leaveReasonIds,
            teamIds,
            setLeaveReasonIds,
            setTeamIds,
            storecastId: props.route.params.storecastId,
          }}
        >
          <WidgetEmployeeLeaveSettingsNavigator
            onCancel={() => {
              props.navigation.goBack();
            }}
          />
        </WidgetSettingsEmployeeLeaveContextProvider>
      }
    />
  );
}
